const adminRoles = [
  'Practice owner/partner',
  'Claimocity Practice Owner',
  'Claimocity Practice Admin',
]
export function hasAdminRole(roles = []) {
  return adminRoles.some((role) => roles.includes(role))
}
